<template>
  <v-form @submit.prevent="submit"
          ref="form"
          v-if="isEmployee"
          :disabled="form.busy">
    <v-card>
      <v-card-title>
        Add {{ user.first_name }} to another team
      </v-card-title>
      <v-card-text class="py-0">
        <v-row>
          <v-col cols="6">
            <v-select v-model="form.role"
                      :label="`${user.first_name} will be a`"
                      :items="teamRoles"
                      item-value="id"
                      item-text="name"
                      :rules="[rules.required]"
                      :error-messages="form.errors.get('role')">
            </v-select>
          </v-col>
          <v-col cols="6">
            <v-select v-model="form.team_id"
                      label="On Team"
                      placeholder="Select the team"
                      :items="filteredTeams"
                      item-value="id"
                      item-text="name"
                      :rules="[rules.required]"
                      :error-messages="form.errors.get('team_id')">
            </v-select>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn type="submit"
               color="primary"
               :disabled="form.busy">
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>
<script>
import {mapGetters} from 'vuex';
import {Form} from 'vform';
import {orderBy} from 'lodash';
import userService from "../../../services/userService";
import formValidation from '../../../plugins/formValidation';
import DOMPurify from 'dompurify';

export default {
  mixins: [formValidation],
  props: {
    user: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      form: new Form({
        team_id: '',
        role: 'Team Member',
      }),
      allTeams: [],
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'isEmployee',
      'isSuperAdmin',
      'teamRoles',
    ]),
    filteredTeams() {
      const teamIDs = this.user.teams.map(t => t.id);
      return this.allTeams.filter(t => {
        return t.is_active && !teamIDs.includes(t.id);
      })
    }
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      axios.get(`/api/teams`)
        .then(response => {
          this.allTeams = orderBy(response.data, ['slug'], ['asc']);
        })
    },
    submit() {
      if (!this.validateForm()) {
        return;
      }
      if (this.form.busy) {
        return;
      }
      this.form.startProcessing();
      userService.addUserToTeam(this.user.id, this.form.team_id, this.form.role)
        .then(() => {
          this.$toast.success(`${DOMPurify.sanitize(this.user.first_name)} was added to that team.`)
          this.$emit('updated');
          this.form.team_id = '';
          this.$refs.form.resetValidation();
        })
        .catch(err => {

        })
        .finally(() => {
          this.form.busy = false;
        })
    }
  }
}
</script>
